import React from 'react'
import { useStateValue } from '@State'
import { DeductionFields } from './DeductionFields'

export const DeductionInputs = () => {
  const [currentState, dispatch] = useStateValue()

  const addDeduction = () => {
    let defaultDeductions = [...currentState.defaultDeductions]
    defaultDeductions.push(['1', 'd', '1', 'point'])
    dispatch({ type: 'modifyDeductions', defaultDeductions })
  }
  return (
    <React.Fragment>
      {currentState.defaultDeductions.map((deduction, i) => (
        <DeductionFields
          timeValue={deduction[0]}
          timeUnit={deduction[1]}
          pointValue={deduction[2]}
          pointUnit={deduction[3]}
          deductionIndex={i}
          allowDelete={currentState.defaultDeductions.length > 1}
          key={i}
        />
      ))}
      {currentState.defaultDeductions.length < 8 && (
        <button
          className="btn btn-sm-myed btn-myed btn-default btn-default-myed"
          type="button"
          onClick={addDeduction}
        >
          Add New Deduction
        </button>
      )}
    </React.Fragment>
  )
}
